module.exports = __webpack_public_path__ + "img/moksir.842cad0e.jpg";